export default "__VITE_PUBLIC_ASSET__4140a270__"